export interface EventDetail {
  el: HTMLElement;
  value?: string,
  event?: Event  
}

export function generateEventDetailPayload(el: HTMLElement, value?: string, event?: Event): EventDetail {
  return { el, value, event };
}

export interface CheckedEventDetail {
  value?: string;
  checked: boolean;
}

export interface CheckboxEventDetail extends CheckedEventDetail {}

export interface ToggleEventDetail extends CheckedEventDetail {}